import { Box, FormHelperText, Grid, Typography } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import { useFormikContext } from "formik";
import { Product } from "../../api/apiClients";
import { getAge, getApplications, isJointApplicationClient } from "../../common/helpers";
import { Client, productDetails } from "../../common/types";
import { Colors, HintText } from "../controls/helpers";
import { ButtonOptionList, ListBase } from "../controls/inputs";

const SelectProduct = ({ client, hideMultipleHint, skipCheckAge }: { client: Client; hideMultipleHint?: boolean; skipCheckAge?: boolean }) => {
  const isJoint = isJointApplicationClient({ ...client });
  const applications = (isJoint && getApplications({ ...client })) || [];
  const age = getAge({ ...client });
  const { setFieldValue, values } = useFormikContext<Client>();
  const checkMinAge = (minAge: number) => {
    return !skipCheckAge && age < minAge;
  };

  return (
    <Grid container spacing={3} justifyContent="center" alignItems="center">
      {isJoint && (
        <Grid item md={7} sm={8} xs={12}>
          {age < 16 && <FormHelperText error>Sorry, you must be 16+ years to apply for products</FormHelperText>}
          <ListBase
            options={applications.map((application) => ({
              label: <Typography style={{ marginTop: 10, color: Colors.DarkGrey }}>{productDetails[application.product].name}</Typography>,
              info: <HintText>{application.nickname} - Joint Account</HintText>,
              control: age < 16 ? <CloseIcon /> : <CheckIcon />,
            }))}
          />
        </Grid>
      )}
      {!isJoint && (
        <>
          <Grid item md={7} sm={8} xs={12} style={{ paddingBottom: 0 }}>
            <Grid container spacing={3} alignItems="center" justifyContent="space-between">
              <ButtonOptionList
                showError
                name="products"
                setFieldValue={setFieldValue}
                values={values.products}
                options={(values.productOptions || [])
                  .map((product) => productDetails[product])
                  .map((product) => ({
                    label:
                      checkMinAge(product.minAge) || (product.value === Product.KiwiSaver && client?.hideKiwiSaver) ? (
                        <>
                          {product.name}
                          {checkMinAge(product.minAge) ? (
                            <FormHelperText error>
                              You must be {product.minAge}+ years to apply for {product.name}
                              {product.value === Product.KiwiSaver && " online"}
                            </FormHelperText>
                          ) : (
                            product.value === Product.KiwiSaver && client?.hideKiwiSaver && <FormHelperText error>You already have an active KiwiSaver account with NZ Funds</FormHelperText>
                          )}
                        </>
                      ) : (
                        product.name
                      ),
                    value: product.value,
                    disabled: checkMinAge(product.minAge) || (product.value === Product.KiwiSaver && client?.hideKiwiSaver),
                    info: product.info,
                    backgroundColor: Colors.White,
                  }))}
              />
            </Grid>
          </Grid>
          {!hideMultipleHint && (
            <Grid item md={7} sm={8} xs={12} style={{ paddingTop: 0 }}>
              <Box textAlign="center">{(values.productOptions || []).length > 1 && <HintText hideMarginTop>You can select multiple.</HintText>}</Box>
            </Grid>
          )}
        </>
      )}
    </Grid>
  );
};

export default SelectProduct;
